import { Container, Grid, Card, CardContent, Typography, Button, Box, useMediaQuery } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import agendamentos from "../../../assets/icons/agendamentos.png";
import boletos from "../../../assets/icons/boletos.png";
import rede_credenciada from "../../../assets/icons/rede-credenciada.png";
import autorizacao_exames from "../../../assets/icons/autorizacao-exames.png";

const AreaBeneficiarioSection = () => {

  const navigate = useNavigate();

  const isMobile = useMediaQuery("(max-width:768px)");
  
  return (
      <Container maxWidth="lg" style={{ padding: '1em', textAlign: 'center' }}>
        {/* Título e Descrição */}
        <Typography variant={isMobile ? "h6" : "h5"} gutterBottom textAlign="left">Facilidade e praticidade em um só lugar</Typography>
        <Typography variant="body1" color="textSecondary" textAlign="justify" paragraph>
          A Área do Beneficiário oferece praticidade e autonomia para que você possa acessar informações de forma rápida e segura, de qualquer lugar.
        </Typography>
    
        {/* Cards de Funcionalidades */}
        <Grid container spacing={4} justifyContent="center">
          {/* Card 1 - Consultar boletos e pagamentos */}
          <Grid item xs={12} sm={6} md={3}>
            <Card style={{ height: '100%' }}>
              <CardContent>
                <img src={boletos} alt="" style={{ height: "60px", margin: "0 auto"}}/>
                {/* <PaymentIcon color="warning" fontSize="large" /> */}
                <Typography variant="h6">Boletos e Pagamentos</Typography>
                <Typography variant="body2" color="textSecondary">
                  Consulte e realize o pagamento de boletos com facilidade.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
    
          {/* Card 2 - Rede credenciada */}
          <Grid item xs={12} sm={6} md={3}>
            <Card style={{ height: '100%' }}>
              <CardContent>
              <img src={rede_credenciada} alt="" style={{ height: "60px", margin: "0 auto"}}/>
                {/* <LocalHospitalIcon color="warning" fontSize="large" /> */}
                <Typography variant="h6">Rede Credenciada</Typography>
                <Typography variant="body2" color="textSecondary">
                  Encontre hospitais, clínicas e laboratórios próximos de você.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
    
          {/* Card 3 - Autorizações e pedidos de exames */}
          <Grid item xs={12} sm={6} md={3}>
            <Card style={{ height: '100%' }}>
              <CardContent>
                <img src={autorizacao_exames} alt="" style={{ height: "60px", margin: "0 auto"}}/>
                {/* <AssignmentTurnedInIcon color="warning" fontSize="large" /> */}
                <Typography variant="h6">Autorizações e Exames</Typography>
                <Typography variant="body2" color="textSecondary">
                  Acompanhe pedidos de exames e autorizações com agilidade.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
    
          {/* Card 4 - Agendamentos */}
          <Grid item xs={12} sm={6} md={3}>
            <Card style={{ height: '100%' }}>
              <CardContent>
                <img src={agendamentos} alt="" style={{ height: "60px", margin: "0 auto"}}/>
                {/* <EventAvailableIcon color="warning" fontSize="large" /> */}
                <Typography variant="h6">Agendamentos</Typography>
                <Typography variant="body2" color="textSecondary">
                  Agende suas consultas e exames de maneira rápida e fácil.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
    
        {/* BOTÃO DESLIGADO A PEDIDO DO RODRIGO */}
        {/* <Box mt={4}>
          <Button variant="contained" color="warning" size="large" onClick={()=> navigate("/beneficiario")}>
            Acessar Área do Beneficiário
          </Button>
        </Box> */}
      </Container>
  );
}

export default AreaBeneficiarioSection;
